import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import { useDispatch, useSelector } from "react-redux";
import { getNodes } from "actions/workflows";
import Button from "components/Elements/Button";
import NiceModal from "@ebay/nice-modal-react";

const Nodes = ({ navigation }) => {
  const location = useLocation();
  const nodes = useSelector((state) => state.workflows.nodes);
  const dispatch = useDispatch();
  const [body, setBody] = useState([]);
  const [head, setHead] = useState([]);
  const [retrievedNodes, setRetrievedNodes] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (nodes.length === 0 && !retrievedNodes) {
      setRetrievedNodes(true);
      dispatch(getNodes());
    } else {
      console.log("NODES 2: ", nodes);
      const keys = ["id", "public_id", "name", "description", "actions"];
      setHead(keys);
      setBody(
        nodes.map((node) => {
          console.log("!!! NODE: ", node);
          const values = [
            node.id,
            node.public_id,
            node.name,
            node.description ?? "",
            <>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  testNode(node);
                }}
              >
                Test
              </Button>
            </>,
          ];
          return values;
        })
      );
    }
  }, [nodes, retrievedNodes, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const editNode = (row) => {
    const node = {};
    head.forEach((key, index) => {
      node[key] = row[index];
    });
    //NiceModal.show('add-node', {node: node});
    navigate(`/admin/node/${node.public_id}`);
  };

  const testNode = (node) => {
    console.log("TEST NODE: ", node);
    NiceModal.show("test-node", { node_id: node.public_id });
  };

  return (
    <div>
      <CardFullTable
        title="Nodes"
        titlebutton={
          <i
            onClick={() => navigate(`/admin/node/`)}
            className="fa fa-plus text-sm cursor-pointer"
          />
        }
        head={head}
        body={body}
        color="white"
        onRowClick={(row) => editNode(row)}
      />
    </div>
  );
};

export default Nodes;
